import 'whatwg-fetch';
import { windowOnLoad } from './common';

/* eslint-disable */
const req = require.context('../css/project', true, /^(.*\.(css$))[^.]*$/igm);
req.keys().forEach((key)=>{req(key);});
/* eslint-enable */

/* eslint-disable import/first */
import '../css/index/case-block.css';
/* eslint-enable import/first */

(() => {
	fetch('static/json/cases.json')
		.then((response) => response.json())
		.then((json) => {
			Array.prototype.forEach.call(json.cases, (caseVal) => {
				document.querySelector('.cases-wrapper').appendChild(
					document.querySelector('.case-block:first-child').cloneNode(true),
				);

				const caseDiv = document.querySelector('.case-block:last-child');
				const caseLink = (() => {
					if (caseVal.link === null) {
						return caseVal.website;
					}

					if (document.querySelector('.cases-wrapper').getAttribute('data-lang') === 'tw') {
						return caseVal.link;
					}

					return `/en${caseVal.link}`;
				})();

				caseDiv.setAttribute('href', caseLink);
				caseDiv.setAttribute('target', caseVal.link === null ? '_blank' : '_self');

				caseDiv.setAttribute('style', `background-image: url(${caseVal.thumb})`);

				if (window.screen.width < 480) {
					caseDiv.setAttribute('style', `background-image: url(${caseVal.rectThumb})`);
				}

				caseDiv.children[0].innerText = caseVal.brand.substring(0, 1);
				caseDiv.children[1].children[0].innerText = caseVal.brand;
				caseDiv.children[1].children[1].innerText =
					document.querySelector('.cases-wrapper').getAttribute('data-lang') === 'tw' ?
						caseVal.desc
						:
						caseVal.enDesc;
			});
		});
})();

window.onload = () => {
	/**
	 * to avoid there is no enough case number
	 * show footer directly
	 */
	if (document.querySelector('.window-section.-space4footer').offsetTop <= window.innerHeight) {
		document.querySelector('.window-section.-footer').classList.add('-bottom');
	}

	windowOnLoad();
};



// WEBPACK FOOTER //
// ./src/js/project.js